import { Wrapper } from 'shared/ui/Wrapper/Wrapper';
import { Button, ButtonTheme } from 'shared/ui/Button/Button';
import { useEffect, useState } from 'react';
import {useApi} from "app/api/APIProvider";
import { Text, TextSize } from 'shared/ui/Text/Text';
import { GoodCard, GoodCardTheme } from 'entities/GoodCard/ui/GoodCard';
import { PolicyCard } from 'entities/PolicyCard';
import { PolicyCardTheme } from 'entities/PolicyCard/PolicyCard';
import { PageLoader } from 'shared/ui/PageLoader/PageLoader';
import { classNames } from 'shared/lib/classNames/classNames';
import { clone, formatNumber, randomNumberFrom1To12 } from 'shared/lib/utils/utils';
import { AppLink } from 'shared/ui/AppLink/AppLink';
import { InfoCard } from 'entities/InfoCard';
import { useDispatch, useSelector } from 'react-redux';
import { userActions } from 'features/User';
import { getCart } from 'features/User/modal/selectors/getUserData/getUserData';
import { policyData } from 'pages/PolicyPage/api/policyData';
import { AssistantOverlay } from 'features/AssistantOverlay';
import Logo from 'shared/assets/img/sber_logo.png';
import plug from 'shared/assets/img/pages/card-plug.png';
import osago from 'shared/assets/img/finances/osago.png';
import CartImage from 'shared/assets/img/pages/cartImage.png';
import PlayIcon from 'shared/assets/icons/playIcon.svg';
import cls from './CartPage.module.scss';

interface IProduct {
    id: number
    max_amount: number,
    name: string,
    price: number,
    required_level: number,
    type: string,
    unique_key: string,
    bought: number,
};

interface IItem {
    amount: number,
    id: string,
    priceAll: number,
    product: IProduct,
}

interface ITotalValues {
    sum: number,
    amount: number,
}

export const CartPage = () => {
    const api = useApi();
    const dispatch = useDispatch();
    const { sum } = useSelector(getCart);
    const [cart, setCart] = useState([]);
    const [isLoaded, setIsLoaded] = useState<boolean>(false);
    const [wallet, setWallet] = useState(0);
    const [totalValues, setTotalValues] = useState<ITotalValues>({ sum: 0, amount: 0 });
    const [goodAmount, setGoodAmount] = useState<number>(0);
    const [isBought, setIsBought] = useState<boolean>(false);
    const [showAssistant, setShowAssistant] = useState<boolean>(false);
    const [productBanner, setProductBanner] = useState<any>();

    const randomProductsName: { [key: number]: string } = {
        1: 'osago',
        2: 'deposit8',
        3: 'dms',
        4: 'property_insurance',
        5: 'nsj',
        6: 'sjz',
        7: 'debit_card',
        8: 'dsj',
        9: 'investment',
        10: 'ipp',
        12: 'credit10',
    };

    const infoBanner = {
        name: "В корзине пусто",
        description: "Зайдите в магазин чтобы купить продукты",
        img: plug,
        button: {
            text: 'Мой магазин',
            url: '/shop'
        },
        cost: "",
        type: "banner",
    };

    // const productBanner = {
    //     name: "Осаго",
    //     description: "Обязательное страхование автогражданской ответственности",
    //     img: osago,
        // button: {
        //     text: 'Оформить',
        //     url: '/finance/policy/osago'
        // },
    //     cost: "",
    //     type: "banner",
    // };

    const InfoCardData = {
        img: CartImage,
        text: "Вы успешно совершили покупку!",
    };

    const getCartData = async () => {
        const { wallet } = await api.GetAllSum();
        const { items, sum, amount } = await api.GetCart();
        // console.log(amount, 'amount from setting value');
        setCart(items);
        setWallet(wallet);
        setGoodAmount(amount);
        setTotalValues((prevValues: ITotalValues) => {
            return {
                ...prevValues,
                sum,
                amount: amount,
            }
        });
        setIsLoaded(true);
    }

    useEffect(() => {
        // console.log(goodAmount, 'amount')
        console.log(wallet, 'wallet')
        console.log(totalValues.sum, 'sum')
    }, [goodAmount])

    const deleteHandler = async (index: number, amount: number | null) => {
        // const productId = cart[index].id;
        const newCartList = [...cart];
        newCartList.splice(index, 1);
        setCart(newCartList);
        if (amount) {
            setGoodAmount((prev) => prev - amount);
        }
        // await api.UpdateCart({ productId, amount: 0 });
    };

    const onBuy = async () => {
        await api.BuyCart();
        setIsBought(true);
        dispatch(userActions.setCartSum(0));
    }

    const getProductBanner = () => {
        const index = randomNumberFrom1To12();
        const bannerName = randomProductsName[index];
        const banner = policyData[bannerName].banner;
        const newBanner = clone(banner);
        //@ts-ignore
        newBanner.button.url = `/finance/policy/${bannerName}`;
        //@ts-ignore
        newBanner.type = 'banner';
        //@ts-ignore
        delete newBanner.button.boughtText;
        setProductBanner(newBanner);
    }

    const messagesForAssistant = 'У тебя не хватает денег';

    useEffect(() => {
        getCartData();
        getProductBanner();
    }, [])

    if (!isLoaded) return <PageLoader />
    return (
        <div className={cls.page}>
            <Wrapper>
                <main className={cls.main}>
                    {
                        cart.length === 0 ? (
                            <>
                                <Text className={cls.title} color="#353850" size={TextSize.text_36}>Корзина</Text>
                                <PolicyCard banner={infoBanner} theme={PolicyCardTheme.banner} />
                            </>
                        )
                        : (
                            <>
                                {
                                    !isBought ? (
                                        <>
                                            <Text className={cls.title} color="#353850" size={TextSize.text_36}>Корзина</Text>
                                            <div className={cls.goodsWrapper}>
                                                {
                                                    cart.map((item: IItem, index: number) => {
                                                        return (
                                                            <GoodCard
                                                                product={item.product}
                                                                amount={item.amount}
                                                                index={index}
                                                                theme={GoodCardTheme.cart}
                                                                deleteHandler={deleteHandler}
                                                                changeAmount={setGoodAmount}
                                                                amountValue={goodAmount}
                                                                key={item.id}
                                                            />
                                                        )
                                                    })
                                                }
                                            </div>
                                            <div className={cls.productDetails}>
                                                <Text className={cls.titleInner} color="#353850" size={TextSize.text_36}>Детали заказа</Text>
                                                <div className={cls.totalInfo}>
                                                    <Text className={cls.titleTotal} color="#353850" size={TextSize.text_20}>Итого</Text>
                                                    <div className={cls.totalInfoInner}>
                                                        <Text color="#353850" size={TextSize.text_18}>{goodAmount} шт.</Text>
                                                        <Text color="#353850" size={TextSize.text_18_600}>{formatNumber(sum)} ₽</Text>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={cls.buttonContainer}>
                                            <AssistantOverlay switcher={showAssistant} message={messagesForAssistant} buttonText={'Понятно'} cb={setShowAssistant}>
                                                <AppLink to={`/finance/policy/credit10?wallet=${wallet}&sum=${sum}`}>
                                                    <Button className={cls.creditButton} theme={ButtonTheme.PRIMARY}>
                                                        Оформить кредит
                                                    </Button>
                                                </AppLink>
                                            </AssistantOverlay>
                                                <Button className={cls.payButton} theme={ButtonTheme.PRIMARY} onClick={() => {
                                                    if (wallet > sum) {
                                                        onBuy();
                                                    } else {
                                                        setShowAssistant(wallet < sum);
                                                    }
                                                }}>
                                                    Купить
                                                </Button>
                                            </div>
                                            <Text className={cls.title} color="#353850" size={TextSize.text_36}>Дополнительные услуги</Text>
                                            <PolicyCard banner={productBanner} theme={PolicyCardTheme.banner} />
                                        </>
                                    ) : (
                                        <InfoCard text={InfoCardData.text} img={InfoCardData.img} />
                                    )
                                }
                            </>
                        )
                    }
                </main>
                <AppLink to="/plot" className={cls.backToGameButton}>
                    <Button
                        theme={ButtonTheme.BACK_TO_GAME}
                        icon={<PlayIcon />}
                        >
                        Продолжить сюжет
                    </Button>
                </AppLink>
                <img className={cls.logo} src={Logo} alt="" />
            </Wrapper>
        </div>
    );
};
